import useGetProjects from "./useGetProjects";

export default function useGetFilterFields() {
  const { projects, isLoadingProjects } = useGetProjects();

  const filterData = projects?.map((project) => ({
    semesters: project.semester ? [project.semester] : [],
    instructors: project.instructors,
    affiliation: project.affiliation,
    tags: project.tags,
    course: project.course ? [project.course] : [],
  }));

  return { filterData, isLoadingFilterData: isLoadingProjects };
}
